import React from 'react'
import PropTypes from 'prop-types'
import Joyride from 'react-joyride'

/* Onbaording (via react-joyride) experience for Attention Index page */
export default class BudgetSubscribersOnBoarding extends React.Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    run: PropTypes.bool.isRequired
  }

  render () {
    // This fills up the logs quite a bit...so let's disable it by default.
    const debug = false
    return (
      <Joyride
        steps={this._steps()}
        run={this.props.run}
        debug={debug}
        continuous
        controlled
        showProgress
        showSkipButton
      />
    )
  }

  _steps () {
    const common = {
      placement: 'auto',
      placementBeacon: 'auto',
      disableBeacon: false,
      styles: {
        options: {
          zIndex: 10000
        }
      },
      locale: { skip: 'Skip tour' }
    }
    let steps = [
      {
        ...common,
        content: (<p>Welcome to the Diesel Labs Budget & Subscribers Dashboard! <br/><br/>Use the buttons at the top of the page to toggle between the three pages: Budget & Subscribers, Subscription Options, and Notes.</p>),
        disableBeacon: true,
        target: '#budgetSubscribersTabs'
      },
      {
        ...common,
        content: (<p>While this preview only displays one quarter of data, additional quarters of Budget & Subscribers information is available and can be exported in our platform.<br/><br/>Let's Go!</p>),
        target: '#actionGroup'
      }
    ]

    return steps
  }
}
